export default {"src":"/_next/static/media/clockIcon.0927d7a4.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};